/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_A2Inputs */

const es_marketplace_seo_galicia_faq_a2 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay ferry regular en temporada y también salidas privadas desde Vigo, Cangas, Baiona y Sanxenxo. Reservar con antelación es recomendable, especialmente en julio y agosto.`)
};

const gl_marketplace_seo_galicia_faq_a2 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai ferry regular en tempada e tamén saídas privadas dende Vigo, Cangas, Baiona e Sanxenxo. Reservar con antelación é recomendable, especialmente en xullo e agosto.`)
};

const en_marketplace_seo_galicia_faq_a2 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is regular ferry service in season plus private trips from Vigo, Cangas, Baiona and Sanxenxo. Booking ahead is recommended, especially in July and August.`)
};

/**
* | output |
* | --- |
* | "There is regular ferry service in season plus private trips from Vigo, Cangas, Baiona and Sanxenxo. Booking ahead is recommended, especially in July and August." |
*
* @param {Marketplace_Seo_Galicia_Faq_A2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_a2 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_A2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_A2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_a2(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_a2(inputs)
	return es_marketplace_seo_galicia_faq_a2(inputs)
});